/* tslint:disable */
/* eslint-disable */
/**
 * FreightSimple Hubble API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 *
 * @export
 * @enum {string}
 */
export enum QuotingStrategyType {
  Instant = "Instant",
  Email = "Email",
}

export function instanceOfQuotingStrategyType(value: any): boolean {
  for (const key in QuotingStrategyType) {
    if (Object.prototype.hasOwnProperty.call(QuotingStrategyType, key)) {
      if (
        QuotingStrategyType[key as keyof typeof QuotingStrategyType] === value
      ) {
        return true;
      }
    }
  }
  return false;
}

export function QuotingStrategyTypeFromJSON(json: any): QuotingStrategyType {
  return QuotingStrategyTypeFromJSONTyped(json, false);
}

export function QuotingStrategyTypeFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): QuotingStrategyType {
  return json as QuotingStrategyType;
}

export function QuotingStrategyTypeToJSON(
  value?: QuotingStrategyType | null,
): any {
  return value as any;
}

export function QuotingStrategyTypeToJSONTyped(
  value: any,
  ignoreDiscriminator: boolean,
): QuotingStrategyType {
  return value as QuotingStrategyType;
}
